import React from "react";
import ConfirmDialog from "./ConfimDialog";
import universalstorageHandler from "../../persistence/UniversalstorageHandler";
import ProjectMetadata from "../../models/ProjectMetadata";
import { showToast } from "../Toasts";

export default function ConfirmDeleteProject(props: {
  projectToDelete: ProjectMetadata;
  setOpen: (v: boolean) => void;
  open: boolean;
  fetchProjects: (force: boolean) => void;
}) {
  const { projectToDelete, setOpen, open, fetchProjects } = props;

  return (
    <ConfirmDialog
      className="dialog-standard"
      title={state.translate("confirmDeleteDialog.deleteProject", "Delete Project?")}
      open={open}
      setOpen={setOpen}
      onConfirm={() => {
        universalstorageHandler.deleteProject(projectToDelete.id).then((ok) => {
          if (ok) {
            showToast({
              text: state.translate("confirmDeleteDialog.projectDeleted", "Das Project wurde gelöscht"),
            });
          } else {
            showToast({
              text: state.translate("confirmDeleteDialog.projectDeleted", "Das Project konnte nicht gelöscht werden"),
            });
          }

          fetchProjects(true);
        });
      }}
    >
      {state.translate(
        "confirmDeleteDialog.sureDeleteT1?",
        `Are you sure you want to delete the project ${projectToDelete.name}?`,
        {
          T1: projectToDelete.name,
        },
      )}
    </ConfirmDialog>
  );
}
